// adminHelp.js

const helpMessages = {
  '/candidate-dashboard': "This is the dashboard page. Here you can see the overview of your system.",
  '/candidate-dashboard/jobs': "In this section, you can view, create, and manage job listings.",
  '/profile': "Here you can update your personal details and preferences.",
  // Add more paths and their respective messages here
};

export function getHelpMessage(pathName) {
  return helpMessages[pathName] || "Help message not available for this page.";
}

// adminHelp.js -- Candidate side

export const getCandidateHelpMessage = (pathname) => {
  switch (pathname) {
    case '/candidate-dashboard':
      return 'This is the dashboard page. Here you can see the overview of your system.';
    case '/candidate-dashboard/jobs':
      return 'Here you can browse and apply for jobs. Explore job listings based on your preferences.';
    case '/candidate-dashboard/companies':
      return 'Discover companies and their profiles. View their job offerings and apply directly.';
    case '/candidate-dashboard/resume':
      return 'Your resume is where you showcase your skills and experience. Update it here.';
    case '/candidate-dashboard/profile':
      return 'View and edit your profile details, including personal information and preferences.';
    case '/candidate-dashboard/payment':
      return 'Manage your payment details, view transactions, and handle subscriptions here.';
    case '/candidate-dashboard/my-application':
      return 'View your job applications and their current status. Track progress on applied jobs.';
    case '/candidate-dashboard/candidate-contact':
      return 'Get in touch with potential employers or recruiters. Manage your contacts here.';
    case '/candidate-dashboard/resume/resumeAdd':
      return 'Add or update your resume to apply for jobs or get noticed by recruiters.';
    case '/candidate-dashboard/companies/companyPage/companyName/:companyName':
      return 'View detailed information about a specific company, its jobs, and culture.';
    case '/candidate-dashboard/resumePopUp':
      return 'Select and upload your resume here. Make sure it’s up-to-date.';
    case '/candidate-dashboard/jobs/dream-company/step/1':
      return 'Find and apply for jobs at your dream company. Filter and search for top companies.';
    case '/candidate-dashboard/jobs/dream-job':
      return 'Search and apply for your dream job based on your skills and preferences.';
    case '/candidate-dashboard/job-description':
      return 'View the detailed description of a job listing. Make sure it fits your interests and qualifications.';
    case '/candidate-dashboard/jobs/job-description/view-more':
      return 'Get more details about a job listing. Read about the responsibilities, qualifications, and more.';
    case '/candidate-dashboard/jobpreference':
      return 'Set your job preferences to get job recommendations that match your criteria.';
    case 'candidate-dashboard/jobs/job-description/':
      return 'see job complete details and recent jobs also and apply it.';
    default:
      return 'No specific help message available for this page.';
  }
};

// adminHelp.js -- HR side

export const getHRHelpMessages = (pathname) => {
  switch (pathname) {
    case '/hr-dashboard':
      return 'Welcome to the HR Dashboard. Here, you can manage your jobs, applications, and company details.';
    case '/hr-dashboard/my-jobs':
      return 'View and manage the jobs you have posted. You can also update or delete them.';
    case '/hr-dashboard/evergreen-jobs':
      return 'Here you can view and manage evergreen jobs that remain open continuously.';
    case '/hr-dashboard/all-jobs/job-form':
      return 'Add a new job by filling out the job form. Make sure to provide all required information.';
    case '/hr-dashboard/evergreen-jobs/update':
      return 'Update the details of an evergreen job. Make necessary changes to keep it current.';
    case '/hr-dashboard/posted-jobs':
      return 'View a list of all the jobs you’ve posted. Keep track of applications for these positions.';
    case '/company-showcase':
      return 'Showcase your company to attract potential candidates. Update your company profile here.';
    case '/hr-dashboard/company-showcase/company-jobs':
      return 'Manage jobs specific to your company. View and edit the job listings associated with your company.';
    case '/hr-dashboard/people':
      return 'View the list of people associated with your company, including employees and candidates.';
    case '/hr-dashboard/hr-applications':
      return 'Manage all job applications. Review applications and move candidates through the hiring process.';
    case '/hr-dashboard/hr-profile':
      return 'View and edit your HR profile. Update your personal information and preferences.';
    case '/hr-dashboard/hr-contact':
      return 'Manage your HR contact details. Update contact information for potential candidates or partners.';
    case '/hr-dashboard/dream-applications':
      return 'View and manage applications from dream candidates. Review and follow up with these top candidates.';
    case '/hr-dashboard/evergreenjobs-applications':
      return 'Manage and track applications for evergreen jobs. Follow up with candidates who have applied.';
    case '/hr-dashboard/hr-applications/view-applications':
      return 'View detailed information about job applications. Track the status and progress of each application.';
    case '/hr-dashboard/hr-applications/view-applications/applicationDetails':
      return 'View detailed information for a specific application, including the applicant’s resume and cover letter.';
    case '/hr-dashboard/my-jobs/addJob':
      return 'Add a new job posting. Provide the necessary details, such as the job title, description, and requirements.';
    case '/hr-dashboard/my-jobs/addJob/jodAddSuccess':
      return 'Success! Your job has been added successfully. You can now manage it from your job listings.';
    case '/hr-dashboard/dream-applications/viewCandidateDetails':
      return 'View detailed information about a dream candidate, including their resume, skills, and qualifications.';
    case '/hr-dashboard/my-jobs/update-job':
      return 'Update an existing job posting. Make changes to the job details or requirements.';
    case '/hr-dashboard/company-showcase':
      return 'View your company profile page. Update the details, including company description, culture, and job listings.';
    case '/hr-dashboard/all-jobs':
      return 'Browse all job listings posted on the platform. Search and filter jobs according to your preferences.';
    case '/hr-dashboard/dream-applications/note':
      return 'Add a note about a dream candidate. Use this to keep track of important details about the candidate.';
    case '/hr-dashboard/tools':
      return 'HR specific tools .';
    default:
      return 'No specific help message available for this page.';
  }
};


